module.exports = ".helper-text {\r\n  font-size: 9px;\r\n  color: #6c757d;\r\n  margin-top: 5px;\r\n}\r\n"